import { Modal } from '@livecontrol/scheduler/components';
import _ from 'lodash';
import type { ReactElement } from 'react';
import { GuestBook } from '../../../store';

interface Props {
  id: string;
  onConfirm: () => void;
  onClose: () => void;
  messages: GuestBook.GuestBookInterface.Message[];
}

export const DeleteModal = ({ onConfirm, id, onClose, messages }: Props): ReactElement => {
  const { deleteGuestBookMessage, loading, error } = GuestBook.useDeleteGuestBookMessage();

  const onOkay = async (): Promise<void> => {
    if (!loading) {
      const messageToDelte = messages.find((message) => message.Timestamp_MessageID === id);

      if (messageToDelte) {
        const { EventID, Timestamp_MessageID } = messageToDelte;

        await deleteGuestBookMessage(EventID, Timestamp_MessageID);
        onConfirm();
        onClose();
      }
    }
  };

  return (
    <Modal.Prompt
      {...{
        show: true,
        icon: 'fal fa-trash-alt',
        title: 'Delete Entry?',
        onCancel: onClose,
        okay: (
          <Modal.Submit loading={loading} variant='danger' onClick={onOkay}>
            Delete
          </Modal.Submit>
        )
      }}
    >
      {error && <div className='error-section'>An error has ocurred</div>}
      <p className='text-center'>This action cannot be undone.</p>
    </Modal.Prompt>
  );
};
